import qs from "querystring";
import { baseUrl } from "./baseUrl";

export const getTasksRoute = (queryParams = { page: 0, size: 20 }) => {
  const queryString = qs.stringify(queryParams);
  return [`${baseUrl}`, "tasks-manager-api", "tasks"].join("/");
};

export const getTasksTypesRoute = () => [`${baseUrl}`, "tasks-manager-api", "task-types"].join("/");

export const getTaskActionsRoute = () => [`${baseUrl}`, "tasks-manager-api", "tasks"].join("/");

export const fetchTaskStatusRoute = ({ taskId }) =>
  [`${baseUrl}`, "tasks-manager-api", "tasks", `${taskId}`, "status"].join("/");

export const fetchTaskByIdRoute = ({ taskId }) =>
  [`${baseUrl}`, "tasks-manager-api", "tasks", `${taskId}`].join("/");

export const getSubtasksRoute = (taskId, status, queryParams = { page: 0, size: 20 }) => {
  const queryString = qs.stringify({ ...queryParams, sort: "statusId,desc" });

  return [
    `${baseUrl}`,
    "tasks-manager-api",
    "tasks",
    taskId,
    status ? `subtasks?status=${status}&${queryString}` : `subtasks?${queryString}`,
  ].join("/")
}

export const getReprocessTaskRoute = (taskId) =>
  [`${baseUrl}`, "tasks-manager-api", "tasks", `reprocess?tasksId=${taskId}`].join("/");
